export default __webpack_public_path__ + "static/media/main_32.492f2f16.jpg";